import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default styled(withParallax(styled.h2`
`))`
`;
